import { createI18n, type I18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'
import { getUserLang } from '@/storage/user'

// 定义语言资源
const messages = {
  'zh-CN': zhCN,
  'en-US': enUS
}

// 获取浏览器默认语言
const defaultLocale = getUserLang() || 'zh-CN'
console.log('defaultLocale', defaultLocale)

// 创建i18n实例
const i18n: I18n = createI18n({
  legacy: false,
  locale: defaultLocale, // 默认语言
  fallbackLocale: 'zh-CN', // 回退语言
  messages // 语言资源
})

export default i18n
